import { CloseButton, Table } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useState } from 'react';
import { KeyedRow } from '../../../components/KeyedRow';
import { TableRowCollapsible } from '../../../components/TableRowCollapsible';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import type { FilterDto } from '../../../util/types/FilterDto';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { PharmacyFirstDto } from '../types/PharmacyFirstDto';
import { PharmacyFirstDetailsTable } from './PharmacyFirstDetailsTable';

interface PharmacyFirstRowProps {
	pharmacyFirst: PharmacyFirstDto;
	filter: FilterDto;
}

export function PharmacyFirstRow({
	pharmacyFirst,
	filter,
}: PharmacyFirstRowProps) {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	return (
		<>
			<KeyedRow onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
				<Table.Td>{undefinedCheck(pharmacyFirst.branch)}</Table.Td>
				<Table.Td>{undefinedCheck(pharmacyFirst.operator)}</Table.Td>
				<Table.Td>{pharmacyFirst.opportunities}</Table.Td>
				<Table.Td>{pharmacyFirst.taken}</Table.Td>
				<Table.Td>{pharmacyFirst.rejected}</Table.Td>
				<Table.Td>{pharmacyFirst.operatorId}</Table.Td>
				<Table.Td>
					<CloseButton
						icon={
							!isDropdownOpen ? (
								<IconChevronDown {...defaultIconStyle} />
							) : (
								<IconChevronUp {...defaultIconStyle} />
							)
						}
						onClick={() => setIsDropdownOpen(!isDropdownOpen)}
					/>
				</Table.Td>
			</KeyedRow>
			<TableRowCollapsible isOpen={isDropdownOpen}>
				<PharmacyFirstDetailsTable
					branchId={pharmacyFirst.branchId}
					operatorId={pharmacyFirst.operatorId}
					filter={filter}
					startLoading={isDropdownOpen}
				/>
			</TableRowCollapsible>
		</>
	);
}
